import { orange } from "@mui/material/colors";
import { IMAGES } from "../page/assets";
import Foon_S1 from "../assets/foon_s/FOON S 02.webp";
import Foon_S2 from "../assets/foon_s/FOON S 03.webp";
import Foon_S3 from "../assets/foon_s/FOON S 04.webp";
import Foon_S4 from "../assets/foon_s/FOON S 05.webp";
import Foon_S5 from "../assets/foon_s/FOON S 06.webp";
import Foon_S6 from "../assets/foon_s/FOON S 07.webp";

export const products = [
  {
    id: 1,
    name: "FOONBUDS PRO 2",
    sku: "FOONBUDSPRO-02",
    sub: "Advanced ANC Earbuds",
    price: "$40",
    oldPrice: "$60",
    stripePriceId: "price_1TU28GA9N7791OLd1ccJlzH4",
    category: "earbuds",
    label: "20% OFF",
    image: {
      black: [IMAGES.STORE_1],
      red: [IMAGES.STORE_1_RED],
      white: [IMAGES.STORE_1_WHITE],
      blue: [IMAGES.STORE_1_BLUE],
    },
    defaultImage: IMAGES.STORE_1,
    button: "Shop Now",
    colors: {
      black: "#000",
      red: "#FF0000",
      white: "#FFFFFF",
      blue: "#0000FF",
    },
    description:
      "FOONBUDS PRO 2 was created for an enhanced listening journey. Hi-Res LDAC™-certified audio combined with Audiodo™ hearing test and compensation delivers rich, detailed sound tailored to your unique hearing profile.",
    seoDescription:
      "Shop FOONBUDS PRO 2 wireless earbuds with Hi-Res LDAC audio, hybrid ANC, spatial sound, and long battery life. Built for immersive everyday listening.",
    features: [],
  },
  {
    id: 2,
    name: "FOONWIRED",
    sku: "FOONWIRED-01",
    sub: "Wireless Earbuds with ANC",
    price: "$15",
    category: "earbuds",
    oldPrice: "$30",
    stripePriceId: "price_1TU28nA9N7791OLdtHsxrxlg",
    image: {
      black: [IMAGES.STORE_2],
    },
    defaultImage: IMAGES.STORE_2,
    button: "Shop Now",
    colors: {
      black: "#000",
    },
    description:
      "High-fidelity wired earphones with a tangle-free cable, ergonomic design, and crystal-clear audio performance. Perfect for reliable, high-quality audio on the go.",
    seoDescription:
      "Discover FOONWIRED high-fidelity wired earphones with a tangle-free cable, ergonomic fit, and clear everyday sound for reliable plug-and-play listening.",
    features: [],
  },
  {
    id: 3,
    name: "Protective Silicone Case",
    sku: "FOONS CASE-01",
    sub: "Wireless Earbuds with ANC",
    price: "$12",
    category: "accessories",
    label: "SOLD OUT*",
    stripePriceId: "price_REPLACE_SILICONE_CASE",
    image: {
      orange: [IMAGES.STORE_3],
    },
    defaultImage: IMAGES.STORE_3,
    button: "Notify Me",
    colors: {
      orange: orange[800],
    },
    description:
      "Durable, high-grade silicone protective case designed for FOONBUDS PRO 2. Shock-absorbent, dust-resistant, and precision-molded for a perfect fit with a soft-touch finish.",
    seoDescription:
      "Protect your earbuds with the FOONBUDS PRO 2 silicone case, designed for a snug fit, shock absorption, and durable day-to-day carry.",
    features: [],
  },
  {
    id: 6,
    name: "FOONGO S",
    sku: "FOONGO S-01",
    sub: "Wireless Earbuds with ANC",
    category: "speakers",
    price: "$40",
    stripePriceId: "price_1TU25XA9N7791OLdMkgGhtUW",
    image: {
      black: [
        IMAGES.STORE_6,
        Foon_S1,
        Foon_S2,
        Foon_S3,
        Foon_S4,
        Foon_S5,
        Foon_S6,
      ],
    },
    defaultImage: IMAGES.STORE_6,
    button: "Notify Me",
    colors: {
      black: "#000",
    },
    description:
      "360° sound, compact driver system, Bluetooth 5.3, 16 hrs battery life, IPX6 waterproof",
    seoDescription:
      "Meet FOONGO S, a compact Bluetooth speaker with 360-degree sound, Bluetooth 5.3, up to 16 hours of battery life, and IPX6 water resistance.",
    features: [],
  },
  {
    id: 4,
    name: "FOONGO L",
    sku: "FOONGO L-01",
    sub: "Wireless Earbuds with ANC",
    category: "speakers",
    price: "$60",
    stripePriceId: "price_1TU27hA9N7791OLd0QBLvXoN",
    image: {
      black: [IMAGES.STORE_4],
    },
    defaultImage: IMAGES.STORE_4,
    button: "Pre-Order",
    colors: {
      black: "#000",
    },
    description:
      "360° sound, dual drivers + passive radiators, Bluetooth 5.3, 24 hrs battery life, IPX7 waterproof",
    seoDescription:
      "Explore FOONGO L, a portable Bluetooth speaker with immersive 360-degree sound, dual drivers, passive radiators, and IPX7 waterproof durability.",
    features: [],
  },
  {
    id: 5,
    name: "FOONHEAD PRO",
    sku: "FOONHEAD PRO-01",
    sub: "Wireless Earbuds with ANC",
    price: "$50",
    category: "headphones",
    label: "NEW",
    stripePriceId: "price_1TU26fA9N7791OLd7ASCQRM0",
    image: {
      black: [IMAGES.STORE_5],
    },
    defaultImage: IMAGES.STORE_5,
    button: "Pre-Order",
    colors: {
      black: "#000",
    },
    description:
      "40mm drivers, adaptive ANC, Bluetooth 5.3, spatial audio, 40 hrs battery life, fast charge",
    seoDescription:
      "Pre-order FOONHEAD PRO over-ear headphones with 40mm drivers, adaptive ANC, spatial audio, Bluetooth 5.3, and long-lasting battery performance.",
    features: [],
  },
  {
    id: 7,
    name: "FOON LANYARD",
    sku: "FOON LANYARD-01",
    sub: "Wireless Earbuds with ANC",
    category: "accessories",
    price: "$20",
    label: "NEW",
    stripePriceId: "price_1TU260A9N7791OLdEb19iDDR",
    image: {
      black: [IMAGES.STORE_7],
    },
    defaultImage: IMAGES.STORE_7,
    button: "Pre-Order",
    colors: {
      black: "#000",
    },
    description:
      "40mm drivers, adaptive ANC, Bluetooth 5.3, spatial audio, 40 hrs battery life, fast charge",
    seoDescription:
      "Shop the FOON lanyard for a lightweight, everyday carry accessory designed to keep your essentials secure and close at hand.",
    features: [],
  },
];
